import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AppContext } from '../../../context/appContext';

const CategoryChip = ({ title, id, activeFilter, activate }) => {
  const active = activeFilter === id ? 1 : 0;
  const [settings] = useContext(AppContext);

  return (
    <Chip
      active={active}
      onClick={() => activate(id)}
      bgcolor={settings?.categoryBg || '#ffe0a2'}
      color={settings?.categoryColor}
      activeBgColor={settings?.activeCategoryBg || '#c8a96d'}
      activeColor={settings?.activeCategoryColor || 'white'}
    >
      {title}
    </Chip>
  );
};

export default CategoryChip;

CategoryChip.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  activeFilter: PropTypes.number.isRequired,
  activate: PropTypes.func.isRequired
};

const Chip = styled.button`
  min-width: 150px;
  width: 20%;
  background-color: ${props =>
    props.active ? props.activeBgColor : props.bgcolor};
  color: ${props => (props.active ? props.activeColor : props.color)};
  font-size: 100%;
  border: none;
  cursor: pointer;
  padding: 12px;
  border-radius: 25px 25px 25px 25px;
  /* text-decoration: ${props => (props.active ? 'underline' : 'none')}; */
  text-decoration-color: #6b5a38;
  text-decoration-style: solid;
  font-family: inherit;
  font-size: 1em;
  text-transform: uppercase;
  outline: none;
  margin: 8px 16px;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.activeBgColor};
    color: ${props => props.activeColor};    
  }
`;
